import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { useLocation } from "react-router-dom";
import { TICKET_FOLDER } from "@constant";
import { classNames } from "@utilscommon";
import LocaleStrings from "@language";

const Footer = (props) => {
  const location = useLocation();

  const handleRedirect = (page) => {
    let param = location.search;

    window.open(`${TICKET_FOLDER}/${page}${param}`, "_blank");
  };

  return (
    <header
      id="MAIN_FOOTER"
      className={classNames("main-footer py-6 px-4 lg:px-6 xl:px-0")}
    >
      <div className="mx-auto max-w-4xl">
        <div className="custom-item-center space-x-3">
          <div
            className="custom-text-theme-md-medium flex items-center cursor-pointer hover:underline break-all"
            onClick={() => handleRedirect("privacy-policy")}
          >
            <div
              className="relative flex h-5 w-5 flex-shrink-0 items-center justify-center"
              aria-hidden="true"
            >
              <div className="h-2 w-2 rounded-full bg-themeLight" />
            </div>
            <span> {LocaleStrings.KPrivacyPolicy}</span>
          </div>
          <div
            className="custom-text-theme-md-medium flex items-center cursor-pointer hover:underline break-all"
            onClick={() => handleRedirect("terms-conditions")}
          >
            <div
              className="relative flex h-5 w-5 flex-shrink-0 items-center justify-center"
              aria-hidden="true"
            >
              <div className="h-2 w-2 rounded-full bg-themeLight" />
            </div>
            <span>{LocaleStrings.kTermsAndConditions}</span>
          </div>
        </div>
      </div>
    </header>
  );
};

const mapStateToProps = (state) => {
  return {
    session: state.session,
  };
};

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Footer);
